import * as React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup, {RadioGroupProps} from '@material-ui/core/RadioGroup';
import * as _ from 'lodash';
import {FormField, ExtendedWrappedFieldProps} from '../FormFields';
import {createGetOrderedOptions, FormRadioOptions, OrderByPropType} from '../utils/orderByUtils';

export enum RadioBoolean {
  true = 'true',
  false = 'false',
}

export interface FormRadioProps extends ExtendedWrappedFieldProps {
  options: FormRadioOptions;
  orderBy?: OrderByPropType;
}

class FormRadio extends React.Component<FormRadioProps & RadioGroupProps> {
  getOrderedOptions = createGetOrderedOptions<FormRadioOptions>();

  render() {
    let {
      showErrors,
      meta: {touched, error},
      options,
      explanationText,
      instructionText,
      label,
      input,
      orderBy,
      ...props
    } = this.props;
    return (
      <FormField
        showErrors={showErrors}
        touched={touched}
        error={error}
        explanationText={explanationText}
        instructionText={instructionText}
        fieldName={input ? input.name : undefined}
        formHelperText={null}
      >
        <FormControl>
          {label ? <InputLabel>{label}</InputLabel> : undefined}
          <RadioGroup {..._.omit(props, 'fullWidth')} {...input}>
            {_.map(this.getOrderedOptions(orderBy, options), ({value, label}) => (
              <FormControlLabel key={value} value={value} control={<Radio color="primary" />} label={label || value} />
            ))}
          </RadioGroup>
        </FormControl>
      </FormField>
    );
  }
}

export default FormRadio;
